import { Alert } from "@mui/material";
import DefaultInput from "../../../../../../common/components/default_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { useEffect } from "react";

/**
 * ConfigureLoginStepThree
 */

type Props = {
  value?: string,
  error?: boolean,
  errorMessage?: string,
  newLoginAccepted?: string,
  onChangeValue?: (value: string) => void,
  onAvailableLogin?: () => void,
  onClick?: () => void,
};

export const ConfigureLoginStepThree = ({
  value,
  error,
  errorMessage,
  newLoginAccepted,
  onChangeValue,
  onAvailableLogin,
  onClick,
}: Props) => {
  useEffect(() => {
    if (value && value.trim().length > 1) {
      onAvailableLogin?.();
    }
  }, [onAvailableLogin, value]);

  return (
    <>
      <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
        <h1 className="text-3xl font-semibold">
          Configurar novo login
        </h1>
        <p className="text-sm font-regular">
          O login que você utilizava no sistema antigo já está em uso por outro usuário no novo sistema. Por esse motivo, será necessário escolher um novo login. Seu login no sistema antigo também será atualizado.
        </p>
      </div>
      <div className="w-full flex gap-4 flex-col items-center justify-center mt-16">
        <div className="w-full">
          <h1 className="text-black dark:text-white font-semibold">Informe os dados abaixo:</h1>
        </div>

        <DefaultInput
          name="new-login"
          label="Novo login"
          size="small"
          value={value ?? ""}
          error={error}
          helperText={errorMessage}
          onChangeValue={(v) => onChangeValue?.(v)}
        />

        {newLoginAccepted &&
          <Alert severity="success">{newLoginAccepted ?? ""}</Alert>}

      </div>
      <div className="w-full flex justify-end my-10">
        <div className="w-44">
          <PrimaryButton onClick={onClick}>Próximo</PrimaryButton>
        </div>
      </div>
    </>
  );
};